import React from 'react';
import PropTypes from 'prop-types';

import InventoryTagItem from '../InventoryTagItem';


const propTypes = {
  tagIconName: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  gray: PropTypes.bool
};

const defaultProps = {
  gray: false
};

export default class BaseInventoryTag extends React.Component {
  render() {
    return (
      <InventoryTagItem
        name={this.props.name}
        icon={this.props.tagIconName}
        iconClass={this.props.iconClass}
        gray={this.props.gray}
        key={this.props.name} />
    );
  }
}

BaseInventoryTag.propTypes = propTypes;
BaseInventoryTag.defaultProps = defaultProps;
